import React, { useCallback, useContext, useEffect, useState } from "react";
import { Alert, Button, Card, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faUser, faUsers, faStore } from "@fortawesome/free-solid-svg-icons";
import NotyfContext from "../contexts/NotyfContext.js";
import { getSystemWhatsAppRegistrationTemplates } from "../api/whatsappSystem.js";
import { WHATSAPP_REGISTRATION_USER_TYPES } from "../utils/whatsappRegistration.js";

const userTypeIcons = { 0: faUser, 1: faUsers, 2: faStore };

export default function WhatsAppRegistrationDefaultsCard({ templates = [], account, onEditDefaults, onRegisterLoader, refreshKey = 0 }) {
  const notyf = useContext(NotyfContext);
  const [references, setReferences] = useState({});
  const [schemaReady, setSchemaReady] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const { data } = await getSystemWhatsAppRegistrationTemplates();
      setReferences(data.templates || {}); setSchemaReady(data.schema_ready === true);
    } catch (_) { setError("Não foi possível consultar os modelos padrão de cadastro."); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => {
    if (onRegisterLoader) return onRegisterLoader("whatsappRegistrationTemplates", load);
    load();
  }, [load, onRegisterLoader]);
  useEffect(() => {
    if (refreshKey > 0) load();
  }, [load, refreshKey]);

  const openEditor = () => {
    if (loading || !schemaReady || account?.status !== "active") {
      if (account?.status !== "active") notyf?.open({ type: "warning", message: "Conecte a conta de WhatsApp antes de configurar os modelos padrão.", ripple: true, dismissible: true });
      return;
    }
    onEditDefaults?.(references);
  };

  return <Card className="border shadow-sm mb-0"
    style={{ cursor: "pointer", transition: "transform 0.15s ease, box-shadow 0.15s ease" }}
    onClick={openEditor}><Card.Body className="p-3">
    <div className="mb-2"><h6 className="fw-bold text-dark mb-0">Modelos padrão de WhatsApp</h6></div>
    <p className="text-muted small mb-3">Configure os 3 modelos de mensagem usados no "Envio automático de WhatsApp após registro"</p>
    {error && <Alert variant="danger" className="p-2">{error}</Alert>}
    {!loading && !schemaReady && <Alert variant="info" className="p-2">A atualização do banco para os modelos de cadastro precisa ser aplicada.</Alert>}
    <div className="border-top pt-2 mt-2">
      {loading ? <Spinner animation="border" size="sm" /> : <div className="d-flex flex-column gap-1 small">
        {WHATSAPP_REGISTRATION_USER_TYPES.map(({ type, label }) => {
          const reference = references[String(type)] || {};
          const template = templates.find((item) => Number(item.template_id) === Number(reference.template_id)
            && Number(item.template_version || item.active_version) === Number(reference.template_version));
          const name = template?.internal_title || (reference.template_id ? `Modelo #${reference.template_id} · versão ${reference.template_version}` : "Sem modelo padrão");
          return <div key={type} className="d-flex justify-content-between align-items-center text-muted">
            <span className="d-flex align-items-center gap-1 flex-shrink-0"><FontAwesomeIcon icon={userTypeIcons[type]} size="xs" /><span>{label}:</span></span>
            <span className="fw-semibold text-dark text-truncate ms-2" style={{ maxWidth: "220px" }} title={name}>{name}</span>
          </div>;
        })}
      </div>}
    </div>
    <div className="d-flex justify-content-end align-items-center mt-3 pt-2 border-top">
      <Button variant="primary" size="sm" className="py-1 px-3" disabled={loading || !schemaReady || account?.status !== "active"}
        onClick={(event) => { event.stopPropagation(); openEditor(); }}>
        <FontAwesomeIcon icon={faPen} className="me-1" />Editar
      </Button>
    </div>
  </Card.Body></Card>;
}
